import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AssetEventSeverity } from '@api';

@Component({
    selector: 'app-event-severity',
    templateUrl: './event-severity.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class EventSeverityComponent {
    public ServerityType = AssetEventSeverity;
    @Input() public severity: AssetEventSeverity;
}
